module.exports = __webpack_public_path__ + "static/media/bg.d78a5319.jpg";